// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-primary);
}

.header-container {
  max-width: var(--page-max);
  height: var(--header-height);
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

/* Logo */
.logo {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  color: var(--text-primary);
  flex-shrink: 0;
}

.logo:hover {
  color: var(--text-primary);
}

.logo-img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}

/* Im Dunkelmodus trägt die weiße Kontur des Logos (wie in der alten Version) */

.logo-text {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.35rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  line-height: 1;
}

/* Hauptnavigation */
.nav {
  display: flex;
  align-self: stretch;
  gap: 0.25rem;
  margin-left: auto;
}

.nav-link {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 0.85rem;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary);
  white-space: nowrap;
}

.nav-link:hover {
  color: var(--text-primary);
}

.nav-link.active {
  color: var(--text-primary);
}

/* Index-Marke wie die 12-Uhr-Markierung einer Lünette */
.nav-link.active::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -1px;
  transform: translateX(-50%);
  border-inline: 6px solid transparent;
  border-bottom: 7px solid var(--accent-primary);
}

/* Aktionen */
.header-actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
}

.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  min-height: 38px;
  padding: 0;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-primary);
}

.icon-btn:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.menu-toggle {
  display: none;
}

/* Mobiles Menü */
.mobile-menu {
  border-top: 1px solid var(--border-primary);
  background: var(--bg-primary);
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem 1rem;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  min-height: 56px;
  padding: 0.6rem 0.5rem;
  border-bottom: 1px solid var(--border-primary);
  font-family: var(--font-display);
  font-size: 1.3rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--text-primary);
}

.mobile-nav-link.active {
  color: var(--accent-primary);
  background: var(--accent-soft);
  box-shadow: inset 3px 0 0 var(--accent-primary);
}

@media (max-width: 900px) {
  .nav {
    display: none;
  }

  .header-actions {
    margin-left: auto;
  }

  .menu-toggle {
    display: inline-flex;
  }

  .instagram-link {
    display: none;
  }
}

@media (max-width: 680px) {
  .header-container {
    padding: 0 1rem;
    gap: 0.75rem;
  }

  .logo-text {
    font-size: 1.2rem;
  }
}

@media (max-width: 360px) {
  .logo-text {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;EAC9C,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.header-container {\n  max-width: var(--page-max);\n  height: var(--header-height);\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n/* Logo */\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  color: var(--text-primary);\n  flex-shrink: 0;\n}\n\n.logo:hover {\n  color: var(--text-primary);\n}\n\n.logo-img {\n  width: 38px;\n  height: 38px;\n  object-fit: contain;\n}\n\n/* Im Dunkelmodus trägt die weiße Kontur des Logos (wie in der alten Version) */\n\n.logo-text {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 1.35rem;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  line-height: 1;\n}\n\n/* Hauptnavigation */\n.nav {\n  display: flex;\n  align-self: stretch;\n  gap: 0.25rem;\n  margin-left: auto;\n}\n\n.nav-link {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0 0.85rem;\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.nav-link:hover {\n  color: var(--text-primary);\n}\n\n.nav-link.active {\n  color: var(--text-primary);\n}\n\n/* Index-Marke wie die 12-Uhr-Markierung einer Lünette */\n.nav-link.active::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  bottom: -1px;\n  transform: translateX(-50%);\n  border-inline: 6px solid transparent;\n  border-bottom: 7px solid var(--accent-primary);\n}\n\n/* Aktionen */\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-shrink: 0;\n}\n\n.icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  min-height: 38px;\n  padding: 0;\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-primary);\n}\n\n.icon-btn:hover {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.menu-toggle {\n  display: none;\n}\n\n/* Mobiles Menü */\n.mobile-menu {\n  border-top: 1px solid var(--border-primary);\n  background: var(--bg-primary);\n}\n\n.mobile-nav {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 1rem 1rem;\n}\n\n.mobile-nav-link {\n  display: flex;\n  align-items: center;\n  min-height: 56px;\n  padding: 0.6rem 0.5rem;\n  border-bottom: 1px solid var(--border-primary);\n  font-family: var(--font-display);\n  font-size: 1.3rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--text-primary);\n}\n\n.mobile-nav-link.active {\n  color: var(--accent-primary);\n  background: var(--accent-soft);\n  box-shadow: inset 3px 0 0 var(--accent-primary);\n}\n\n@media (max-width: 900px) {\n  .nav {\n    display: none;\n  }\n\n  .header-actions {\n    margin-left: auto;\n  }\n\n  .menu-toggle {\n    display: inline-flex;\n  }\n\n  .instagram-link {\n    display: none;\n  }\n}\n\n@media (max-width: 680px) {\n  .header-container {\n    padding: 0 1rem;\n    gap: 0.75rem;\n  }\n\n  .logo-text {\n    font-size: 1.2rem;\n  }\n}\n\n@media (max-width: 360px) {\n  .logo-text {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
